<template>
    <div class="card-body">
        <b-skeleton-wrapper :loading="!renderComponent">
            <template #loading>
                <b-row class="mb-4">
                    <b-col cols="3">
                        <b-skeleton animation="fade" width="30%" class="mb-4"></b-skeleton>
                        <b-skeleton type="input" animation="fade" width="100%" class="mb-4"></b-skeleton>
                    </b-col>
                    <b-col cols="3">
                        <b-skeleton animation="fade" width="30%" class="mb-4"></b-skeleton>
                        <b-skeleton type="input" animation="fade" width="100%" class="mb-4"></b-skeleton>
                    </b-col>
                </b-row>
                <b-row class="mb-4">
                    <b-col cols="6">
                        <b-skeleton type="input" animation="fade" width="100%" class="mb-4"></b-skeleton>
                    </b-col> </b-row><b-row class="mb-4">
                    <b-skeleton type="" animation="fade" width="100%" class="mb-4"></b-skeleton>
                </b-row>
                <b-skeleton-table :rows="4" :columns="8"
                    :table-props="{ bordered: true, striped: true }"></b-skeleton-table>
            </template>
        </b-skeleton-wrapper>
    </div>
</template>

<script>
export default {
    name: 'StockSlipSkeleton',
    props: ['renderComponent'],
};
</script>
